import service from "@/utils/request";

export const getAllLeads = async (page) => {
    try{
        const response = await service.get('/leads?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch Leads:", e);
    }
}
export const addLead = async (lead) => {
    try{
        const response = await service.post('/leads' , lead);
        return response;
    }catch(e){
        console.error("Failed to add Leads:", e);
    }
}
export const assignLead = async (data) => {
    try{
        console.log('here api')
        console.log(data)
        const response = await service.post('/leads-assign' , data);
        return response;
    }catch(e){
        console.error("Failed to add Leads:", e);
    }
}
export const deleteLead = async (id) => {
    try{
        const response = await service.delete('/leads/'+id);
        return response;
    }catch(e){
        console.error("Failed to delete Leads:", e);
    }
}

export const filter = async ( form , pageno) => {
    try{
        const response = await service.post('/filter-leads?page='+pageno , form);
        return response;
    }catch(e){
        console.error("Failed to Filter Leads:", e);
    }
}
export const getUserLeads = async (id ,pageno) => {
    try{
        const response = await service.get('/user-leads/'+id+'?page='+pageno);
        return response;
    }catch(e){
        console.error("Failed to User Leads:", e);
    }
}

export const updateLead = async (lead) => {
    try{
        const response = await service.post('/leads/'+lead.id , lead);
        return response;
    }catch(e){
        console.error("Failed to update Leads:", e);
    }
}

export const getLeadActions = async (leadId, page) => {
    try {
        const response = await service.get(`/leads/${leadId}/actions?page=${page}`);
        return response; 
    } catch (e) {
        console.error("Failed to fetch Lead Actions:", e);
    }
};
